import { render } from "./LegalPolicies.vue?vue&type=template&id=eb0e589a&scoped=true"
import script from "./LegalPolicies.vue?vue&type=script&lang=js"
export * from "./LegalPolicies.vue?vue&type=script&lang=js"

import "@/assets/scss/_legalPolicies.scss?vue&type=style&index=0&id=eb0e589a&lang=scss&scoped=true"
import "./LegalPolicies.vue?vue&type=style&index=1&id=eb0e589a&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb0e589a"]])

export default __exports__